import {
    GetList,
    PostLocation,
    DeleteLocation,
    GetLocation,
    PutLocation,
    ChangeLocationStatus,
} from '@src/services/location'

export const state = {
    listLocation: [],
}

export const getters = {
    totalList(state) {
        return state.listLocation.data ?
            state.listLocation.data.totalItemCount :
            0
    },
}

export const mutations = {
    FETCH_LOCALS(state, locals) {
        state.listLocation = locals
    },
    SET_STATE(state, payload) {
        if (state.listLocation.data) {
            state.listLocation.data.items.find(({ publicId }) => {
                return publicId === payload.publicId
            }).status = payload.status
        }
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((team) => {
            state.listLocation.data.items.push(team)
        })
    },
}

export const actions = {
    async fetchLocationList({ commit }, parameters = {}) {
        const resp = await GetList(parameters)

        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
        }
    },
    async getLocation({ commit }, parameters) {
        const resp = await GetLocation(parameters)
        if (resp && resp.status === 200) {
            return resp.data.data
        }
    },
    async saveNewLocation({ commit }, parameters) {
        const resp = await PostLocation(parameters)
        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
            return true
        }
        return false
    },
    async editLocation({ commit }, parameters) {
        const resp = await PutLocation(parameters)
        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
            return true
        }
        return false
    },
    async delete({ commit, dispatch }, data) {
        const resp = await DeleteLocation(data)

        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async changeActiveStatus({ commit, dispatch }, data) {
        const resp = await ChangeLocationStatus(data)
        if (resp.status === 200) {
            commit('SET_STATE', data)
            dispatch('fetchList')
            return true
        }
        return false
    },
    async nextPage({ commit }, currentPage) {
        const resp = await GetList(currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
}